import type { GridDensity } from '@mui/x-data-grid-pro';

import { useLocalStorage } from '@/hooks/useLocalStorage';

/**
 * Generic hook for managing DataGrid density with localStorage persistence
 *
 * @param storageKey - Unique key for localStorage (e.g., 'employees-density')
 * @param defaultDensity - Default density setting (default: 'standard')
 * @returns Density state and setter
 */
export const useDensity = (
  storageKey: string,
  defaultDensity: GridDensity = 'standard',
) => {
  const [density, setDensity] = useLocalStorage<GridDensity>(
    storageKey,
    defaultDensity,
  );

  return {
    density,
    setDensity,
  };
};
